import fin from "./financial_decisions";

const BASELINE_PART1 = [75, 80];   
const BASELINE_PART2 = [150, 160]; 

const PART1_OBSERVATIONS = [
  'fd_choice1', 'fd_choice2', 'fd_choice3', 'fd_choice4', 'fd_choice5',
  'fd_1month1', 'fd_2today1'
];

const PART2_OBSERVATIONS = [
  'fd_choice6', 'fd_choice7', 'fd_choice8', 'fd_choice9', 'fd_choice10',
  'fd_7months1', 'fd_6months1'
];

const DELTA_SCALE_OBS = ['fd_1month1', 'fd_2today1', 'fd_7months1', 'fd_6months1'];

function getPart(observation) {
  if (PART1_OBSERVATIONS.includes(observation)) return 1;
  if (PART2_OBSERVATIONS.includes(observation)) return 2;
  return 1; // default to part 1
}

function scaleMoney(value, factor) {
  const num = typeof value === "string" ? parseFloat(value) : value;
  return String(Math.round(num * factor));
}

export function createCustomFinancialDecisions(opts = {}) {
  const {
    currencyCode = "USD",
    finInitialAmountPart1 = BASELINE_PART1,
    finInitialAmountPart2 = BASELINE_PART2,
    enableScreenSubmit = true
  } = opts;

  console.log("--------------------------------------");
  console.log(finInitialAmountPart1, finInitialAmountPart2);
  console.log(BASELINE_PART1, BASELINE_PART2);
  console.log("--------------------------------------");
  console.log(currencyCode);

 
  const factors = {
    part1: {
      value1: finInitialAmountPart1[0] / BASELINE_PART1[0],
      value2: finInitialAmountPart1[1] / BASELINE_PART1[1]
    },
    part2: {
      value1: finInitialAmountPart2[0] / BASELINE_PART2[0],
      value2: finInitialAmountPart2[1] / BASELINE_PART2[1]
    }
  };

  // Transform screens
  const screens = fin.screens.map((screen) => {
    const cloned = { ...screen, module: 'custom_financial_decisions' };

    if (screen.type === 'fin_choice' && screen.meta) {
      const part = getPart(screen.observation);
      const partFactors = part === 1 ? factors.part1 : factors.part2;
      const meta = { ...screen.meta };

      // Scale value_1 and value_2 using their respective factors
      if (meta.value_1 !== undefined) {
        meta.value_1 = scaleMoney(meta.value_1, partFactors.value1);
      }
      if (meta.value_2 !== undefined) {
        meta.value_2 = scaleMoney(meta.value_2, partFactors.value2);
      }

      meta.prefix = currencyCode;

      // Scale delta for specific observations
      if (DELTA_SCALE_OBS.includes(screen.observation) && meta.generate?.delta !== undefined) {
        meta.generate = {
          ...meta.generate,
          delta: Math.round(meta.generate.delta * partFactors.value1)
        };
      }

      cloned.meta = meta;
    }

    return cloned;
  });

  // Transform skip_keys
  const skip_keys = Object.fromEntries(
    Object.entries(fin.skip_keys).map(([key, value]) => {
      const part = getPart(key);
      const partFactors = part === 1 ? factors.part1 : factors.part2;
      const baselineValue2 = part === 1 ? BASELINE_PART1[1] : BASELINE_PART2[1];

      return [
        key,
        {
          values: value.values.map((rawValue) => {
            // Use value2 factor if this value matches the baseline value_2, otherwise use value1 factor
            const parsedValue = parseFloat(rawValue);
            const factor = parsedValue === baselineValue2 
              ? partFactors.value2 
              : partFactors.value1;
            return scaleMoney(rawValue, factor);
          }),
          targets: value.targets
        }
      ];
    })
  );

  return {
    screens,
    skip_keys,
    screen_submit: enableScreenSubmit
  };
}
export default createCustomFinancialDecisions();
